import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {minimalButtonStyle} from '../styles';
import {TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getString, getInPojo} from '@packages/utilities/data-utils';

const UserAccountSubscriptionCancelButton = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    return (
      <button
        {...generateAttributes(attributes, classes)}
        type="button"
        {...{[USYS_DATA_ATTRS.subscriptionCancel]: true}}
      >
        {getString(getInPojo(data, ['buttonText']))}
      </button>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Subscription Cancel Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  render: UserAccountSubscriptionCancelButton,
  showEmpty: false,
  lockedStyles: {
    display: {
      when: true,
      message:
        'The display setting can’t be changed for a subscription cancel button.',
    },
  },
  style: {
    base: {
      main: {
        noPseudo: {
          ...minimalButtonStyle,
        },
      },
    },
  },
  constraints: {
    ancestors: [{is: 'UserAccountSubscriptionListItem', rule: 'ExactlyOne'}],
    pinToParent: true,
  },
  fields: {
    buttonText: withSystem(
      {
        defaultValue: 'Cancel',
        label: 'Cancel Text',
        displayName: 'Cancel Text',
        isFullWidth: true,
      },
      TText
    ),
  },
});

export default config;
